import React from 'react';


import Container from '../Container';
import StandardLayout from '../StandardLayout';


function StandardContainer(props) {

    return (
        <StandardLayout>
            <Container {...props}/>
        </StandardLayout>
    );
}


StandardContainer.propTypes = {
    ...Container.propTypes
};

StandardContainer.defaultProps = {
    ...Container.defaultProps
};


export default StandardContainer;
